import { FC, useEffect, useState } from "react";

import Box from "@mui/material/Box";
import { SxProps, Theme } from "@mui/material/styles";

import Loader from "components/Loader";

import { useBrowserDetect } from "hooks/useBrowserDetection";

import styles from "./styles";

type Animation3dViewProps = {
  animationUrl: string;
  sx?: SxProps<Theme>;
};

const Animation3dView: FC<Animation3dViewProps> = ({
  animationUrl,
  sx = [],
}) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const { isSafari } = useBrowserDetect();

  useEffect(() => {
    isSafari && setIsLoaded(true);
  }, [isSafari]);

  return (
    <Box sx={styles.wrapper}>
      {!isLoaded && <Loader center />}
      <Box
        component="iframe"
        onLoad={() => setIsLoaded(true)}
        src={animationUrl}
        sx={[styles.animationClass, ...(Array.isArray(sx) ? sx : [sx])]}
      />
    </Box>
  );
};
export default Animation3dView;
